import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "Company",
    links: [
      { label: "Home", path: "/" },
      { label: "About Us", path: "/about" },
      { label: "Services", path: "/services" },
      { label: "Portfolio", path: "/portfolio" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        {/* Top Row */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-8 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/30">
                <i className="ri-anchor-line text-[#00ff88] text-lg leading-none" />
              </div>
              <div>
                <div className="text-white font-bold text-base tracking-widest font-inter">AWWAL</div>
                <div className="text-white/30 text-[10px] tracking-[0.2em] font-inter">MARINE & ENGINEERING</div>
              </div>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-6 max-w-xs font-inter">
              Building the future of digital entertainment through innovative game development, dynamic social platforms, and elite guild operations.
            </p>

          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <div className="text-[#00ff88] text-xs tracking-[0.25em] uppercase font-bold mb-5 font-inter">
                {col.title}
              </div>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-white/40 text-sm hover:text-white transition-colors cursor-pointer font-inter"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs tracking-widest font-inter">
            © 2026 AWWAL MARINE & ENGINEERING SDN. BHD. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" rel="nofollow" className="text-white/25 text-xs hover:text-white/50 transition-colors cursor-pointer font-inter">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="text-white/25 text-xs hover:text-white/50 transition-colors cursor-pointer font-inter">
              Terms of Service
            </a>
            <span className="text-white/25 text-xs font-inter">awwaleng.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
